import { render, staticRenderFns } from "./ModalAppMarket.vue?vue&type=template&id=08388706&scoped=true"
import script from "./ModalAppMarket.vue?vue&type=script&lang=js"
export * from "./ModalAppMarket.vue?vue&type=script&lang=js"
import style0 from "./ModalAppMarket.vue?vue&type=style&index=0&id=08388706&prod&lang=stylus&scoped=true"
import style1 from "./ModalAppMarket.vue?vue&type=style&index=1&id=08388706&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08388706",
  null
  
)

export default component.exports